import createActions from 'utils/redux/createActions'

export default createActions([
	'ATTACHMENTS_ADD'
  , 'ATTACHMENT_DELETE'
  , 'ATTACHMENTS_INIT'
])



// WEBPACK FOOTER //
// ./src/actions/attachmentsActions.js